import React from 'react';

type ButtonSize = 'md' | 'lg' | 'none' | 'square-sm' | 'square-md' | 'square-xs' | 'circle-xxs' | 'square-xxs' | false;

interface IProps {
    onClick?: (val?: any) => void;
    onMouseEnter?: (val?: any) => void;
    onMouseLeave?: (val?: any) => void;
    onDoubleClick?: (val?: any) => void;
    reference?: any;
    children: React.ReactNode;
    className?: string;
    btnSpinnerClass?: string;
    disabled?: boolean;
    loading?: boolean;
    icon?: any;
    iconSide?: string;
    type?: 'submit' | 'button' | 'reset' | undefined;
    autofocus?: boolean;
    size?: ButtonSize;
    ariaLabel?: string;
}

const ButtonCmp = ({
    children,
    reference,
    btnSpinnerClass,
    onClick = undefined,
    onDoubleClick = undefined,
    onMouseEnter = undefined,
    onMouseLeave = undefined,
    className = '',
    disabled = false,
    loading = false,
    type = 'submit',
    icon = '',
    iconSide = 'left',
    autofocus = false,
    size,
    ariaLabel,
}: IProps) => (
    <button
        ref={reference}
        aria-label={ariaLabel}
        className={`btn-default ${
            size === 'lg'
                ? 'btn-custom-lg'
                : size === 'md'
                ? 'btn-custom-md'
                : size === 'none'
                ? ''
                : size === 'square-sm'
                ? 'btn-square-sm'
                : size === 'square-md'
                ? 'btn-square-md'
                : size === 'square-xs'
                ? 'btn-square-xs'
                : size === 'circle-xxs'
                ? 'btn-circle-xxs'
                : size === 'square-xxs'
                ? 'btn-square-xxs'
                : 'btn-custom-sm'
        } ${className} ${disabled ? 'cursor-default pointer-events-none opacity-60 ' : ''}`}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onDoubleClick={onDoubleClick}
        type={type}
        autoFocus={autofocus}
    >
        {loading && <span className={`loading loading-spinner lg:w-4 lg:h-4 h-3 w-3 text-xs ${btnSpinnerClass} ${loading ? 'pr-2' : 'pr-0'} `}></span>}
        {iconSide === 'left' && icon ? icon : ''}
        {children}
        {iconSide === 'right' && icon ? icon : ''}
    </button>
);

export default ButtonCmp;
